import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import {
  getClientById,
  getClientDocument,
  getClientDocuments,
  getUser,
} from "../service/weexpertService";
import { useQuery } from "react-query";
import { Loader } from "@/components/ProtectedRoute";
import { Button } from "@/components/ui/button";
import { DocumentViewComponent } from "@/components/clients/document.view";
import ClientDocumentEditPopup from "@/components/popups/client-documents.upload.edit.popup";

export const ClientDocumentViewPage = () => {
  const { t } = useTranslation();
  const { clientId, documentId } = useParams();

  const { data: client, isLoading } = useQuery({
    queryKey: ["client", clientId],
    queryFn: () => {
      return getClientById(clientId);
    },
  });
  const { data: document, isDocumentLoading } = useQuery({
    queryKey: ["document", documentId],
    queryFn: () => {
      return getClientDocument(documentId);
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isDocumentLoading || !document|| !document.data || !document.data.document) {
    return <Loader />;
  }
  return (
    <div className="relative bg-grayLightMainBg px-8">
      <div className="sticky left-0 top-16 z-10 w-full bg-grayLightMainBg">
        <div className="flex justify-between py-8 items-center ">
          <div className=" w-5/12  text-4xl ">Document</div>
          <div className="flex justify-end">

            <ClientDocumentEditPopup doc={document.data.document} />
            <Link to={`/client/${client.data.id}/documents`}>
              <Button className="min-w-20">{t("button_back")}</Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full pt-2">
        <div className=" text-2xl ">
          {client.data && client.data.firstName + " " + client.data.lastName}
        </div>
      </div>
      <div>
        {document.data && (
          <DocumentViewComponent document={document.data.document} id={client.data.id}/>
        )}
      </div>
    </div>
  );
};
